import { render, staticRenderFns } from "./attribute.vue?vue&type=template&id=d2426d94&scoped=true&"
import script from "./attribute.vue?vue&type=script&lang=js&"
export * from "./attribute.vue?vue&type=script&lang=js&"
import style0 from "./attribute.vue?vue&type=style&index=0&id=d2426d94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2426d94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2426d94')) {
      api.createRecord('d2426d94', component.options)
    } else {
      api.reload('d2426d94', component.options)
    }
    module.hot.accept("./attribute.vue?vue&type=template&id=d2426d94&scoped=true&", function () {
      api.rerender('d2426d94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/page_weChat/attribute.vue"
export default component.exports